import { ACT_AS_SESSION_KEY } from '@/shared/actAs';

export function isBetaClient(): boolean {
  return import.meta.env.VITE_APP_ENV === 'beta';
}

export function getActAsUserId(): string | null {
  if (!isBetaClient() || typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage.getItem(ACT_AS_SESSION_KEY)?.trim() || null;
}

export function setActAsUserId(userId: string): void {
  if (!isBetaClient() || typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(ACT_AS_SESSION_KEY, userId.trim());
}

export function clearActAsUserId(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(ACT_AS_SESSION_KEY);
}
